export const API_KEY = '453dabb4-7645-4626-a1bb-477dff3aa557';

/**
 * Official Generalitat links. Centralized so they are easy to update when the
 * administration changes a URL. Aleta never copies the official forms: it
 * always links to the latest version published by the Generalitat.
 */
export const OFFICIAL_LINKS = Object.freeze({
    gencatBoardRegistration: {
        label: 'Tràmit: inscripció dels òrgans de govern d\'una associació',
        url: 'https://tramits.gencat.cat/ca/tramits/tramits-temes/Inscripcio-dels-organs-de-govern-duna-associacio',
    },
    gencatRenewalForm: {
        label: 'Model oficial: certificat de renovació de la junta directiva (PDF)',
        url: 'https://justicia.gencat.cat/web/shared/OVT/Departaments/JUS/Documents/formularis_pdf/20189-cert_renov_total_jd.pdf',
    },
    gencatRegistryCertificate: {
        label: 'Tràmit: certificació de dades registrals d\'una associació',
        url: 'https://tramits.gencat.cat/ca/tramits/tramits-temes/Certificacio-de-dades-registrals-duna-associacio-00001',
    },
    gencatEntitiesGuide: {
        label: 'Guia d\'entitats de la Generalitat',
        url: 'https://justicia.gencat.cat/ca/serveis/guia_d_entitats/',
    },
    gencatFaq: {
        label: 'Preguntes freqüents sobre associacions (Departament de Justícia)',
        url: 'https://justicia.gencat.cat/ca/ambits/dret_i_entitats_juridiques/associacions/preguntes_mes_frequents/',
    },
    stripeRequiredVerification: {
        label: 'Stripe: informació de verificació requerida',
        url: 'https://docs.stripe.com/connect/required-verification-information',
    },
});

export const CHANGE_TYPE_LABELS = Object.freeze({
    initial: 'Primera configuració a Aleta',
    total: 'Renovació total',
    partial: 'Renovació parcial',
    reelection: 'Reelecció',
});

export const CHANGE_TYPE_HELP = Object.freeze({
    initial: 'Registrem a Aleta la junta que ja consta al Registre d\'Associacions, sense cap canvi.',
    total: 'Ha acabat el mandat i s\'ha escollit una junta nova (encara que repeteixin algunes persones).',
    partial: 'El mandat continua vigent però canvien alguns càrrecs o persones.',
    reelection: 'S\'han tornat a escollir les mateixes persones per a un nou mandat.',
});

export const LIFECYCLE_LABELS = Object.freeze({
    draft: 'Esborrany',
    current: 'Vigent',
    superseded: 'Anterior',
    cancelled: 'Cancel·lat',
});

export const GENCAT_STATUS_LABELS = Object.freeze({
    not_started: 'Pendent de comunicar',
    preparing: 'Preparant la comunicació',
    submitted: 'Marcada com a presentada',
    correction_required: 'Cal corregir documentació',
    registered: 'Inscrita al Registre',
});

export const STRIPE_STATUS_LABELS = Object.freeze({
    not_applicable: 'Sense Stripe',
    not_started: 'Sense consultar',
    action_required: 'Cal completar dades',
    submitted: 'Stripe està revisant',
    verified: 'Verificat per Stripe',
    restricted: 'Pagaments o payouts aturats',
});

export const STRIPE_REASON_LABELS = Object.freeze({
    no_account: 'Aquesta colla no té cap compte de Stripe Connect.',
    account_invalid: 'Stripe ja no reconeix el compte connectat. Revisa Tresoreria > Pagaments.',
    stripe_unavailable: 'No s\'ha pogut consultar Stripe ara mateix. Torna-ho a provar en uns minuts.',
    charges_disabled: 'Stripe ha aturat els cobraments amb targeta.',
    payouts_disabled: 'Stripe ha aturat els payouts (transferències al compte de la colla).',
    past_due: 'Hi ha requisits de Stripe amb la data límit superada.',
    disabled: 'Stripe ha restringit el compte fins que es completin els requisits.',
    requirements_due: 'Stripe demana dades pendents.',
    directors_mismatch: 'Els directius declarats a Stripe no coincideixen amb la junta legal registrada aquí.',
    pending_verification: 'Stripe està revisant les dades enviades.',
});

export const EVENT_LABELS = Object.freeze({
    term_created: 'Es comença a preparar el mandat',
    term_updated: 'S\'actualitza l\'esborrany',
    term_corrected: 'Es corregeix el mandat vigent',
    term_activated: 'Es confirma la junta com a vigent',
    term_superseded: 'El mandat queda substituït per un de nou',
    term_cancelled: 'Es descarta l\'esborrany',
    term_annulled: 'S\'anul·la el mandat vigent',
    term_restored: 'Es restaura el mandat anterior',
    gencat_started: 'Es comença la comunicació a la Generalitat',
    gencat_submitted: 'Es marca la comunicació com a presentada',
    gencat_correction_required: 'La Generalitat demana correccions',
    gencat_registered: 'Es registra la inscripció al Registre d\'Associacions',
    gencat_reverted: 'Es desfà l\'últim pas de la Generalitat',
    stripe_opened: 'S\'obre Stripe per actualitzar la junta',
    stripe_status_changed: 'Stripe canvia d\'estat',
    certificate_requested: 'Es sol·licita el certificat registral per a Stripe',
    certificate_received: 'Es rep el certificat registral de la Generalitat',
    certificate_reverted: 'Es desfà l\'últim pas del certificat',
    certificate_document_uploaded: 'Es guarda el PDF del certificat d’inscripció',
    certificate_document_removed: 'S’elimina el PDF del certificat d’inscripció',
});

export const DEFAULT_ROLE_SUGGESTIONS = Object.freeze([
    'Presidència',
    'Copresidència',
    'Vicepresidència',
    'Secretaria',
    'Tresoreria',
    'Vocalia',
]);

/**
 * The wizard only defines the board (who, since when). Following up the
 * Generalitat and Stripe processes happens on the status screen as tasks.
 */
export const WIZARD_STEPS = Object.freeze([
    { key: 'type', label: 'Tipus de canvi' },
    { key: 'dates', label: 'Data i mandat' },
    { key: 'composition', label: 'Composició' },
]);

export const LEGAL_BOARD_RETURN_PATH = '/quotes/junta-legal';
